export const COLORS = {
  marigold: "#E46A12",
  terracotta: "#B6452C",
  gulal: "#D11B6B",
  mango: "#FFC533",
  mehendi: "#1F7A3A",
  royalBlue: "#1E4ED8",
  deepMaroon: "#3A0B1E",
  kraft: "#3B2416",
  khoya: "#FFF3D6",
  lassi: "#FFFDF7",
  gold: "#D6A84A",
  ink: "#1A1208",
};

export const PHONE_DISPLAY = "+91 99093 99882";
export const PHONE_TEL = "tel:+919909399882";
export const EMAIL_PLACEHOLDER = "hello@desimastaani.com"; // placeholder - update with real email

export const INSTAGRAM_URL = "https://www.instagram.com/desimastaanikulfi_official/";
export const FACEBOOK_URL = "https://www.facebook.com/p/Desi-Mastani-61564024326804/";
export const LOGO_SRC = "/desi-mastaani-logo.webp";

export const WHATSAPP_URL =
  "https://wa.me/919909399882?text=" +
  encodeURIComponent("Namaste! Mujhe Desi Mastaani ke baare mein jaanna hai.");

export const WHATSAPP_FRANCHISE_URL =
  "https://wa.me/919909399882?text=" +
  encodeURIComponent("Namaste! Mujhe Desi Mastaani franchise ke baare mein jaanna hai.");

export const IMAGES = {
  heroMatka:
    "https://images.unsplash.com/photo-1517244683847-7456b63c5969?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  heroDessert:
    "https://images.unsplash.com/photo-1517244683847-7456b63c5969?crop=entropy&cs=srgb&fm=jpg&q=85&w=700",
  potWall:
    "https://images.unsplash.com/photo-1699190772797-f4b7f130e644?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  terracottaTexture:
    "https://images.unsplash.com/photo-1580026926593-14aba6c81e65?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  kitchenProcess:
    "https://images.unsplash.com/photo-1635952346904-95f2ccfcd029?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  heritageMarket:
    "https://images.unsplash.com/photo-1646578515903-67873a5398f9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  festiveFlower:
    "https://images.unsplash.com/photo-1487608817221-9e860a03ea49?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
};
